import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout, selectCurrentUser } from '../../features/auth/authSlice';
import { useToast } from '../../contexts/ToastContext';
import OmButton from '../ui/OmButton';
import OMLogo from '../../assets/OM-logo.png';

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const user = useSelector(selectCurrentUser);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  
  const handleLogout = async () => {
    setIsLoggingOut(true);
    
    // Minimum duration for loading feedback
    const minDuration = 300;
    const startTime = Date.now();
    
    try {
      await dispatch(logout()).unwrap();
      
      // Ensure minimum duration
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minDuration - elapsed);
      
      setTimeout(() => {
        toast.showSuccess('Logged out successfully');
        navigate('/login');
        setIsLoggingOut(false);
      }, remaining);
      
    } catch (error) {
      // Ensure minimum duration even on error
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minDuration - elapsed);
      
      setTimeout(() => {
        toast.showError(`Logout failed: ${error}`);
        setIsLoggingOut(false);
      }, remaining);
    }
  };
  
  return (
    <header className="bg-crystal-white border-b-3 border-deep-jungle shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <img 
            src={OMLogo} 
            alt="OM Logo" 
            className="h-10 w-auto sm:h-12" 
          />
          <div className="border-l-2 border-woodland-moss/30 pl-4">
            <h1 className="text-lg sm:text-xl lg:text-2xl font-display font-bold text-deep-jungle tracking-tight">
              Corporate Claims Portal
            </h1>
          </div>
        </div>
        
        {user && (
          <div className="flex items-center space-x-3 sm:space-x-6">
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-xs uppercase tracking-wide text-steel font-medium">
                Signed in as
              </span>
              <span className="text-sm font-display font-semibold text-deep-jungle">
                {user.username}
              </span>
            </div>
            
            <div className="sm:hidden">
              <span className="text-sm font-medium text-deep-jungle">
                {user.username}
              </span>
            </div>
            
            <div className="h-8 w-px bg-woodland-moss/20 hidden sm:block"></div>
            
            <OmButton
              onClick={handleLogout}
              disabled={isLoggingOut}
              variant="outlined"
              className="px-4 py-2 sm:px-6 sm:py-2.5"
            >
              {isLoggingOut ? (
                <>
                  <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2"></div>
                  <span className="hidden sm:inline">Signing out...</span>
                  <span className="sm:hidden">Out</span>
                </>
              ) : (
                <>
                  <span className="hidden sm:inline">Sign Out</span>
                  <span className="sm:hidden">Out</span>
                </>
              )}
            </OmButton>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
